import { DateTime } from 'luxon'
import { createContext, Dispatch, SetStateAction } from 'react'
import { EventCategory, EventLocation, EventTherapist, ParsedBookableEvent } from '../types'

type BookingCalendarContextData = {
    nextPage: () => void
    previousPage: () => void
    noEventsAvailable: boolean
    earliestStart: DateTime<true>
    setEarliestStart: Dispatch<SetStateAction<DateTime<true>>>
    latestEnd: DateTime<true>
    setLatestEnd: Dispatch<SetStateAction<DateTime<true>>>
    categories: Record<number, EventCategory>
    therapists: Record<number, EventTherapist>
    selectedDate: DateTime<true>
    setSelectedDate: Dispatch<SetStateAction<DateTime<true>>>
    filtersAreOpen: boolean
    setFiltersAreOpen: Dispatch<SetStateAction<boolean>>
    filteredEvents: ParsedBookableEvent[]
    setFilteredEvents: Dispatch<SetStateAction<ParsedBookableEvent[]>>
    eventsForSelectedDate: ParsedBookableEvent[]
    setEventsForSelectedDate: Dispatch<SetStateAction<ParsedBookableEvent[]>>
    availableLocations: EventLocation[]
    setAvailableLocations: Dispatch<SetStateAction<EventLocation[]>>
    selectedLocations: EventLocation[]
    setSelectedLocations: Dispatch<SetStateAction<EventLocation[]>>
    availableCities: string[]
    setAvailableCities: Dispatch<SetStateAction<string[]>>
    selectedCities: string[]
    setSelectedCities: Dispatch<SetStateAction<string[]>>
    noEventsForFilter: boolean
    setNoEventsForFilter: Dispatch<SetStateAction<boolean>>
    availableWeekdays: number[]
    setAvailableWeekdays: Dispatch<SetStateAction<number[]>>
    selectedWeekdays: number[]
    setSelectedWeekdays: Dispatch<SetStateAction<number[]>>
    availableCategoryIDs: number[]
    setAvailableCategoryIDs: Dispatch<SetStateAction<number[]>>
    selectedCategoryIDs: number[]
    setSelectedCategoryIDs: Dispatch<SetStateAction<number[]>>
    availableTherapistIDs: number[]
    setAvailableTherapistIDs: Dispatch<SetStateAction<number[]>>
    selectedTherapistIDs: number[]
    setSelectedTherapistIDs: Dispatch<SetStateAction<number[]>>
    isEventNotAvailableDialogOpen: boolean
    setIsEventNotAvailableDialogOpen: Dispatch<SetStateAction<boolean>>
    showWeekend: boolean
    isMultiUser: boolean
    showQuickFilters: boolean
    showLocationQuickFilter: boolean
    // Fixed category ID for move booking flow - locks calendar to only show events of this category
    fixedCategoryId?: number
}

export const BookingCalendarContext = createContext<BookingCalendarContextData>({} as BookingCalendarContextData)
